import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { NoticeMedia } from '../notice.model';
import { LightboxService } from '../../job-viewer/lightbox/lightbox.service';
import { NoticeMediaImageItemComponent } from './notice-media-image-item.component';
import { NoticeImageDocumentItemComponent } from './notice-media-document-item.component';
import { OverflowTooltipDirective } from '../../../directives/overflow-tooltip.directive';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'notice-media-gallery',
  imports: [
    NoticeMediaImageItemComponent,
    NoticeImageDocumentItemComponent,
    OverflowTooltipDirective,
    MatTooltipModule,
    MatIconModule,
    MatButtonModule
  ],
  providers: [LightboxService],
  host: { class: 'block' },
  template: `
    @if (medias.length) {
      <div class="flex flex-nowrap gap-20 pt-12 pb-10 overflow-x-scroll custom-thin-scrollbar">
        @for (file of medias; track file; let i = $index) {
          <div class="group relative w-100">
            @if (file.url) {
              <notice-media-image-item
                [url]="file.url"
                [adminView]="adminView"
                (openLightbox)="!adminView && openLightbox(file.id)" />
            } @else {
              <notice-media-document-item [document]="file" [adminView]="adminView" />
            }
            <div
              #fileName="overflow"
              class="h-20 text-xs/[20px] bg-charcoal-35 text-white pl-5 rounded-b truncate"
              [overflowTooltip]="file.fullName"
              [matTooltip]="fileName.tooltip">
              {{ file.fullName }}
            </div>
            @if (adminView) {
              <mat-icon
                class="absolute! -top-12 -right-12 bg-charcoal text-white! size-24! text-14! rounded-[50%] p-5 cursor-pointer"
                (click)="removeAttachment.emit(file)">
                close
              </mat-icon>
            }
          </div>
        }
      </div>
    }
  `
})
export class NoticeMediaGalleryComponent {
  @Input() adminView = false;
  @Input() medias: NoticeMedia[] = [];
  @Output() removeAttachment = new EventEmitter<NoticeMedia>();

  #lightboxService = inject(LightboxService);

  openLightbox(imageId: number): void {
    const images = this.medias.filter(({ url }) => url);
    const selectedIndex = images.findIndex(({ id }) => id === imageId);
    this.#lightboxService.open({ imageGallerySelector: { images, selectedIndex } });
  }
}
